module.exports = __webpack_public_path__ + "static/media/capa_acrilico.cb05267a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/capa_acrilico.jpg
// module id = 308
// module chunks = 0